import { default as authopssI8ovT0Meta } from "/var/www/cellcom/production/frontend/src/pages/auth.vue?macro=true";
import { default as indexIEea7XLHlSMeta } from "/var/www/cellcom/production/frontend/src/pages/browsing/index.vue?macro=true";
import { default as indexjDj6agbXXTMeta } from "/var/www/cellcom/production/frontend/src/pages/cinema/archive/[channelId]/index.vue?macro=true";
import { default as indexDUoY1P5RjrMeta } from "/var/www/cellcom/production/frontend/src/pages/cinema/category/[categoryId]/index.vue?macro=true";
import { default as indexPyOlKu5c5UMeta } from "/var/www/cellcom/production/frontend/src/pages/cinema/culture/index.vue?macro=true";
import { default as indexRjuZunWVuXMeta } from "/var/www/cellcom/production/frontend/src/pages/cinema/documentals/index.vue?macro=true";
import { default as indexqKGGKpabz8Meta } from "/var/www/cellcom/production/frontend/src/pages/cinema/index.vue?macro=true";
import { default as _91id_93UCe73AyfMUMeta } from "/var/www/cellcom/production/frontend/src/pages/container/[id].vue?macro=true";
import { default as indexw3K5nxxteXMeta } from "/var/www/cellcom/production/frontend/src/pages/favorite/index.vue?macro=true";
import { default as indexDqqkAzHVnvMeta } from "/var/www/cellcom/production/frontend/src/pages/history/index.vue?macro=true";
import { default as indexaRZmEr4xoyMeta } from "/var/www/cellcom/production/frontend/src/pages/index.vue?macro=true";
import { default as indexpFyOI74RTwMeta } from "/var/www/cellcom/production/frontend/src/pages/item/[id]/detail/index.vue?macro=true";
import { default as indexSa0K54faygMeta } from "/var/www/cellcom/production/frontend/src/pages/item/[id]/index.vue?macro=true";
import { default as indexuvwCQqDc2QMeta } from "/var/www/cellcom/production/frontend/src/pages/search/index.vue?macro=true";
export default [
  {
    name: "auth",
    path: "/auth",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/auth.vue")
  },
  {
    name: "browsing",
    path: "/browsing",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/browsing/index.vue")
  },
  {
    name: "cinema-archive-channelId",
    path: "/cinema/archive/:channelId()",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/cinema/archive/[channelId]/index.vue")
  },
  {
    name: "cinema-category-categoryId",
    path: "/cinema/category/:categoryId()",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/cinema/category/[categoryId]/index.vue")
  },
  {
    name: "cinema-culture",
    path: "/cinema/culture",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/cinema/culture/index.vue")
  },
  {
    name: "cinema-documentals",
    path: "/cinema/documentals",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/cinema/documentals/index.vue")
  },
  {
    name: "cinema",
    path: "/cinema",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/cinema/index.vue")
  },
  {
    name: "container-id",
    path: "/container/:id()",
    meta: _91id_93UCe73AyfMUMeta || {},
    component: () => import("/var/www/cellcom/production/frontend/src/pages/container/[id].vue")
  },
  {
    name: "favorite",
    path: "/favorite",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/favorite/index.vue")
  },
  {
    name: "history",
    path: "/history",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/history/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/index.vue")
  },
  {
    name: "item-id-detail",
    path: "/item/:id()/detail",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/item/[id]/detail/index.vue")
  },
  {
    name: "item-id",
    path: "/item/:id()",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/item/[id]/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/var/www/cellcom/production/frontend/src/pages/search/index.vue")
  }
]